


























import { Component, Vue } from 'vue-property-decorator';
import { logOut } from '@/auth/auth';

@Component
export default class UserLogoutModal extends Vue {
  loading: boolean = false;

  logOut() {
    this.loading = true;
    logOut();
  }
}
